import { render, staticRenderFns } from "./ManOrganizationFormWizard.vue?vue&type=template&id=c4f9ca6a&scoped=true&"
import script from "./ManOrganizationFormWizard.vue?vue&type=script&lang=ts&"
export * from "./ManOrganizationFormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./ManOrganizationFormWizard.vue?vue&type=style&index=0&id=c4f9ca6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f9ca6a",
  null
  
)

export default component.exports